module.exports = __webpack_public_path__ + "static/img/精细化3.4f83610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/精细化3.jpg
// module id = NBDX
// module chunks = 1